import styles from './Select.module.css'
import SelectPicker from 'react-select';

function SelectMultiple({ text, name, options, handleOnChange, value, isMulti, placeholder, disabled, isClearable}) {
    const valores = Array.isArray(value) ? value : [value]
    const valorSelecionado = isMulti
        ? options.filter((option) => valores.includes(option.value))
        : options.find((option) => option.value === valores[0]) || null

    return (
        <div className={styles.form_control}>
            <label htmlFor={name}>{text}</label>
            <SelectPicker 
                    isMulti={(isMulti ? isMulti : false)}
                    onChange={handleOnChange}  
                    name={name} 
                    id={name} 
                    placeholder={(placeholder ? placeholder : text)}
                    options={options}
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                    menuPosition="fixed"
                    styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                    value={valorSelecionado}
                    isClearable={isClearable === true}
                    isDisabled={disabled} />
        </div>
    )
}

export default SelectMultiple
